import {createApiResource} from 'data/utils';

const resource = createApiResource({
	name: 'apiKey',
	pathName: '/apiKeys',
	unwrap: x => x,
});

const {removeAllResourceQueries} = resource.createQueryClientHelpers();
export const removeApiKeys = removeAllResourceQueries;
export const useApiKeys = resource.createUseQueryIndex();
